import { FC, useMemo } from "react"
import { DLMSiteApplication } from "../../../../_models"
import { DetailFileDownload, extractROIDetailFiles } from "../../../../../../../components/layout"

type Props = {
  site: DLMSiteApplication 
}
  
const DLMLabellingROICell: FC<Props> = ({site}) => {


  const roiFiles = useMemo(() => {
     

    if (! (site && site?.rois && site.rois.length > 0)) {
      return [];
    }   

    return extractROIDetailFiles(site.rois, site.dlmApplication.id);
   
  }, [site]);

  if (! (roiFiles && roiFiles.length > 0)) {
    return null;
  }
  
  return (
  <>
  {
  roiFiles.map((dat: any, idx: number) => (
  <DetailFileDownload key={`roiFile-{idx}`} labelText={dat.showFileTitle} file={dat.showFile} hasChanged={dat.hasChanged} data={dat} canReplace />
  ))
  }
  </>
  )
}

export { DLMLabellingROICell }